// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-DeleteConfirm-DeleteConfirm-module__title--fVP71 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.src-components-DeleteConfirm-DeleteConfirm-module__title--fVP71 svg {
  color: #e09d2b;
}
/*# sourceMappingURL=DeleteConfirm.module.css.map */`, "",{"version":3,"sources":["webpack://./DeleteConfirm.module.less","webpack://./src/components/DeleteConfirm/DeleteConfirm.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ACCF;ADJA;EAKI,cAAA;ACEJ;AACA,mDAAmD","sourcesContent":[".title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  svg {\n    color: #e09d2b;\n  }\n}\n",".title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.title svg {\n  color: #e09d2b;\n}\n/*# sourceMappingURL=DeleteConfirm.module.css.map */"],"sourceRoot":""}]);
// Exports
export var title = `src-components-DeleteConfirm-DeleteConfirm-module__title--fVP71`;
export default ___CSS_LOADER_EXPORT___;
